import app from '@/app';

/* @ngInject */
function Iri($resource) {
	return $resource(
		'api/iris/:id',
		{ id: '@id' },
		{
			query: { method: 'GET' },
			purge: { method: 'DELETE' }
		}
	);
}

app.factory('Iri', Iri);
